import { extend } from 'flarum/extend';
import app from 'flarum/app';

import SettingsPage from 'flarum/components/SettingsPage';
import LogInModal from 'flarum/components/LogInModal';
import HeaderSecondary from 'flarum/components/HeaderSecondary';
import LogInButtons from 'flarum/components/LogInButtons';
import LogInButton from 'flarum/components/LogInButton';
import Button from 'flarum/components/Button';

import WeappLoginModal from "./components/WeappLoginModal";

app.initializers.add('sayiwen/flarum-ext-auth-wechat', () => {

    extend(SettingsPage.prototype, 'accountItems', (items) => {
        items.remove("changeEmail");
        const {
            data: {
                attributes: {
                    isLinked = false,
                    isMpLinked = false,
                },
            },
        } = app.session.user;
        if(!isLinked){
            items.add('linkWeChat',
            	<Button
            		className= 'Button WeChatButton--sucsess'
                    icon= 'fab fa-weixin'
                    onclick = {() => app.signUp(false)}>
            		{app.translator.trans(`sayiwen-auth-wechat.forum.buttons.link`)}
            	</Button>,1
            );
        }
        // if(isMpLinked){
        //     items.add('linkWeChatMp',
        //     	<Button
        //     		className= 'Button WeChatButton--sucsess'
        //             icon= 'fab fa-weixin'
        //             onclick = {() => app.signUp(true)}>
        //     		{app.translator.trans(`sayiwen-auth-wechat.forum.buttons.link_mp`)}
        //     	</Button>,
        //     	1
        //     );
        // }
    });

    extend(LogInButtons.prototype, 'items', function (items) {
    	items.add('wechat',
    	<Button 
    	icon ='fab fa-weixin'
    	onclick = {()=>app.signUp()}
    	className ='Button LogInButton--wechat LogInButton'
    	>{app.translator.trans('sayiwen-auth-wechat.forum.buttons.login')}</Button>,1);
    });
    
    extend(HeaderSecondary.prototype, 'items', (items) => {
        items.remove("signUp");
    });
    
    extend(LogInModal.prototype, 'body', (body) => {
        //body[1] = (<p></p>);
    });
    extend(LogInModal.prototype, 'footer', (footer) => {
        footer[0] = "";
        footer[1] = "";
    });
    
    
});

app.isMiniProgram = false;
wx.miniProgram.getEnv(function(res) {
    app.isMiniProgram = res.miniprogram;
});
app.signUp = (isMp)=>{
    if(app.isMiniProgram){
        wx.miniProgram.redirectTo({url: '/pages/auth/auth'})
    }else{
        app.modal.show(WeappLoginModal,{isMp:isMp});
    }
}